import React, { useCallback, useState } from 'react';

import { FormPayload, ViewNames } from './types';
import { initialValues } from './contants';
import GeneralSection from './Components/Sections/GeneralSection/GeneralSection';
import { signUpSchema } from './Utils/ValidateUtils';
import { Container } from './SignUpFormModule.styles';
import { AuthModuleProps } from '../../../Interfaces/Pages';
import { AdditionalSection } from './Components/Sections/AdditionalSection/AdditionalSection';
import SuccessView from './Components/SuccessView/SuccessView';
import { ServerError } from '../../../Interfaces/Validation';
import { useClientServerValidationHook } from '../../../Hooks/Validation/cliendServerValidationHook/clientServerValidationHook';
import { AnySchema } from 'yup';
import { submitHandle } from './Utils/SubmitHandleUtils';
import { WIDTH_MODULE } from '../../../Constants/Auth';
import { AuthFormLayout } from '../../../Components/Forms/Auth';

interface Props extends AuthModuleProps {}

export const SignUpFormModule: React.FC<Props> = ({ width = WIDTH_MODULE }) => {
  const [view, setView] = React.useState<ViewNames>(ViewNames.Form);
  const [errors, setErrors] = useState<ServerError[]>([]);

  const resetErrorsHandle = useCallback(() => {
    setErrors(() => []);
  }, []);

  const toSignUpHandler = useCallback(
    async (values: FormPayload) => {
      await submitHandle({
        values: values,
        preAction: resetErrorsHandle,
        doAction: () => {
          setView(ViewNames.Success);
        },
        errorAction: (errors: ServerError[]) => {
          setErrors(errors);
        },
      });
    },
    [resetErrorsHandle],
  );
  const { validation } = useClientServerValidationHook<FormPayload>({
    schema: signUpSchema as AnySchema<unknown, unknown, unknown>,
    serverErrors: errors,
  });

  return (
    <Container width={width}>
      {view === ViewNames.Form && (
        <AuthFormLayout<FormPayload>
          title="Sign Up Form"
          validate={validation}
          initialValues={initialValues}
          submitFormHandler={toSignUpHandler}
          resetErrorsHandle={resetErrorsHandle}
        >
          <GeneralSection />
          <AdditionalSection />
        </AuthFormLayout>
      )}
      {view === ViewNames.Success && <SuccessView />}
    </Container>
  );
};
